export const environment = {
    production: true,
    rootPath: '/api',
    domainPrefix: '',
    copyright: '© $YEAR$ Estra S.p.A.',
    address: 'Estra S.p.A. - P. Iva 02149060978 - R.E.A. 505831 - Capitale sociale € 228.334.000,00 i.v.',
    forbiddenWords: ['admin', 'default', 'member', 'root', 'test', 'user']
};
